module.exports = __webpack_public_path__ + "img/GDGif.f10a1f3a.gif";